import { useContext } from 'react';
import { SMLThemeContext, SMLThemeContextValue } from './SMLThemeContext';

export function useSMLTheme(): SMLThemeContextValue {
  return useContext(SMLThemeContext);
}
